import * as React from 'react';
import { BaseForm } from './Base';
import theme from '../../utils/theme';
import countries from '../../utils/countries';

type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;

export interface InputProps extends SelectProps {
  id: string;
  label: string;
  tooltip?: string;
  field: any;
  onValueChange: Function;
  defaultValue: any;
}

export type Option = {
  label: string;
  value: string;
};

export const CountrySelect = ({
  label,
  id,
  tooltip,
  field,
  onValueChange,
  ...rest
}: InputProps) => (
  <BaseForm label={label} id={id} tooltip={tooltip}>
    <select
      id={id}
      onChange={(e) => onValueChange(field, e.target.value)}
      className={theme.form.field.input}
      {...rest}
    >
      <option value={null}>Please select</option>
      {countries().map((option: Option) => (
        <option value={option.value}>{option.label}</option>
      ))}
    </select>
  </BaseForm>
);
